import { render, staticRenderFns } from "./AppFooterSocialLinks.vue?vue&type=template&id=19f94760"
import script from "./AppFooterSocialLinks.vue?vue&type=script&lang=js"
export * from "./AppFooterSocialLinks.vue?vue&type=script&lang=js"
import style0 from "./AppFooterSocialLinks.vue?vue&type=style&index=0&id=19f94760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports